import { useMemo } from "react";

import { useFeaturePullRequestsData } from "@/feature/data/useFeaturePullRequestsData";
import { PullRequest } from "@reflag/shared/featureAPI";

// Helper function to get the latest PR by creation date
export function useLatestPullRequest(featureId: string): {
  latestPullRequest: PullRequest | null;
  isLoadingLatestPullRequest: boolean;
} {
  const { data: pullRequests, isLoading: isLoadingLatestPullRequest } =
    useFeaturePullRequestsData(featureId);

  const displayablePullRequests = useMemo(
    () =>
      pullRequests?.data.filter(
        (pr) => pr.status !== "creating" && pr.status !== "error",
      ) ?? [],
    [pullRequests],
  );

  if (displayablePullRequests.length === 0) {
    return { latestPullRequest: null, isLoadingLatestPullRequest };
  }
  return {
    latestPullRequest: [...displayablePullRequests].sort(
      (a: PullRequest, b: PullRequest) =>
        new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime(),
    )[0],
    isLoadingLatestPullRequest,
  };
}
